import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.locale = window.location.pathname.split("/")[1].toUpperCase();
  }

  gtagClick(e) {
    const label = e?.params?.label || "";
    const lang = this.locale.length > 2 || !this.locale ? "EN" : this.locale;

    if (label === "appstore") {
      gtag("event", "click_download_app", {
        site_language: lang,
        store: "App Store",
        place: "footer"
      });
      if (typeof rdt === "function") {
              rdt("track", "Custom", { customEventName: "click_download_app" });
            }
    } else if (label === "googleplay") {
      gtag("event", "click_download_app", {
        site_language: lang,
        store: "Google Play",
        place: "footer"
      });
      if (typeof rdt === "function") {
              rdt("track", "Custom", { customEventName: "click_download_app" });
            }
    } else if (["instagram", "facebook", "youtube"].includes(label)) {
      gtag("event", "click_social", {
        site_language: lang,
        network: label,
        place: "footer"
      });
      if (typeof rdt === "function") {
              rdt("track", "Custom", { customEventName: "click_social" });
            }
    } else {
      gtag("event", "navigation_click", {
        site_language: lang,
        place: "footer",
        menu_block: label
      });
      if (typeof rdt === "function") {
              rdt("track", "Custom", { customEventName: "navigation_click" });
            }
    }
  }
}
